/*
 Created by CHT 2019/10/12 14:47
 */
import BaseItem from '../BaseItem'
import { DATA_TYPE__JSON, FORM_ITEM__LOCATION } from '../types'
import {isObject} from "../../../assets/js/Untis";

class Location extends BaseItem {
  constructor () {
    super()

    this.value = {
      province: '',
      city: '',
      county: '',
      detailAddress: '',
      latitude: null,
      longitude: null
    }

    this.showGeographic = 0    // 显示经纬度
    this.allowChange = 0       // 是否允许微调
    this.changeScope = -1   // 微调范围
    this.autoLocation = 0 // 自动定位

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title () {
    return this.fieldTitle || Location._title
  }

  set title (val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

Location._title = '定位'
Location.type = FORM_ITEM__LOCATION
Location.use = true
Location.icon = 'iconfont icon-location'

Location.prototype.type = Location.type
Location.prototype.dataType = DATA_TYPE__JSON

Location.prototype.setValue = function (val) {
console.log('setvalue', val)
  if (val && !isObject(val)) {
    console.error('the value of location is not an object --> ', val, this.dataId)
    this.value = {
      province: "",
      city: "",
      county: "",
      detailAddress: "",
      latitude: null,
      longitude: null
    }
    return
  }

  this.value = val || {
    province: "",
    city: "",
    county: "",
    detailAddress: "",
    latitude: null,
    longitude: null
  }
}
Location.prototype.getValue = function () {
  return this.value
}

Location.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    defaultValue: this.defaultValue,
    showGeographic: this.showGeographic,
    allowChange: this.allowChange,
    changeScope: this.changeScope,
    autoLocation: this.autoLocation
  }
}
Location.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.showGeographic) this.showGeographic = opts.showGeographic
  if (opts.allowChange) this.allowChange = opts.allowChange
  if (opts.changeScope) this.changeScope = opts.changeScope
  if (opts.autoLocation) this.autoLocation = opts.autoLocation

  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
  }
}
Location.prototype.clearValue = function () {
  Object.assign(this.value, {
    province: '',
    city: '',
    county: '',
    detailAddress: '',
    latitude: null,
    longitude: null
  })
}
Location.prototype.filterOpts = [
  {
    name: '属于',
    method: 'all'
  },
  {
    name: '不属于',
    method: 'nin'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  }
]
Location.prototype.valueToString = function (value) {
  value = value || this.value
  return [value.province, value.city, value.county, value.detailAddress].join('')
}
export default Location
